var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartContainer",staticStyle:{"width":"100%","height":"100%"}},[_c('highcharts',{ref:"aChart",staticClass:"mt-4",staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }